import { createFileRoute } from "@tanstack/react-router";
import { ExportTaskDetailPage } from "@client/components/doc-center/export-task/export-task-detail-page";

export const Route = createFileRoute("/_app/data-center/exports_/$exportId")({
  component: ExportDetailRoute,
});

function ExportDetailRoute() {
  const { exportId } = Route.useParams();
  return <ExportTaskDetailPage exportId={exportId} />;
}
